(function () {
  function init(root) {
    if (root.dataset.mgReady) return;
    root.dataset.mgReady = '1';

    var mainBtn = root.querySelector('[data-main]');
    var mainImg = root.querySelector('[data-main-img]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var box = root.querySelector('[data-lightbox]');
    var boxImg = root.querySelector('[data-lightbox-img]');
    var closeBtn = root.querySelector('[data-lightbox-close]');
    if (!mainImg) return;

    var original = {
      src: mainImg.getAttribute('src'),
      srcset: mainImg.getAttribute('srcset'),
      sizes: mainImg.getAttribute('sizes'),
      alt: mainImg.getAttribute('alt') || ''
    };
    var current = null;

    function showOriginal() {
      mainImg.setAttribute('src', original.src);
      if (original.srcset) mainImg.setAttribute('srcset', original.srcset);
      if (original.sizes) mainImg.setAttribute('sizes', original.sizes);
      mainImg.setAttribute('alt', original.alt);
    }

    function pick(thumb) {
      thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
      if (current === thumb) {
        current = null;
        showOriginal();
        return;
      }
      current = thumb;
      thumb.setAttribute('aria-current', 'true');
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.setAttribute('src', thumb.dataset.src);
      mainImg.setAttribute('alt', thumb.dataset.alt || '');
    }

    function openBox() {
      boxImg.setAttribute('src', mainImg.currentSrc || mainImg.getAttribute('src'));
      boxImg.setAttribute('alt', mainImg.getAttribute('alt') || '');
      box.hidden = false;
      closeBtn.focus();
    }

    function closeBox() {
      box.hidden = true;
      mainBtn.focus();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { pick(t); });
    });
    mainBtn.addEventListener('click', openBox);
    box.addEventListener('click', closeBox);
    closeBtn.addEventListener('click', function (e) { e.stopPropagation(); closeBox(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) closeBox();
    });
  }

  function run(scope) {
    (scope || document).querySelectorAll('[data-mg-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();

  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
